<template>
  <div class="info">
    <div class="slh"></div>
    <div class="content">
      <div class="first">
        <span class="blue">中铁建工集团第一建设有限公司</span
        >源于1953年设立的铁道部建厂工程局第一建筑工程处，
        前身为2002年改制后组建成立的中铁建工集团有限公司北京分公司，
        位于北京市丰台区，是世界企业、世界品牌双500强企业中国中铁的三级公司，
        经营范围涵盖铁路站房、大型公建、商业综合体、商业住宅、市政与基础设施等领域，
        现有职工2000余人，先后荣获鲁班奖、詹天佑奖、中国安装工程优质奖、
        中国钢结构金奖等34项国家级荣誉，连续五年获评
        <span class="weatblue">“中国中铁三级工程公司20强”</span>。
      </div>
      <div class="first">
        公司始终秉持着“勇于跨越、追求卓越”的企业精神，坚持“以诚信、智慧、科技、管理铸就更高质量和更富情感的建筑精品”的建设理念，不断推动企业高质量发展，被誉为“铁路站房建设王牌军”和“大型公共建筑专家”。
      </div>
      <div class="second">
        <div class="introimg"></div>
        <div class="second_con">
          <div>
            <span class="blue">在铁路建设方面，</span
            >公司先后承建了新中国第一座大型铁路站房——北京站、中国首座BIM试点铁路站房——兰州西站、中国东北第一大铁路枢纽站房——沈阳南站、世界单体最大的欧洲新艺术运动风格建筑——哈尔滨站、中国第一座智能铁路站房——清河站、中国第一座最大双层车场铁路站房——丰台站、中国千年大计第一个重大交通枢纽站房——雄安站等70余座工程质量优、技术水平高、社会效益好，展示中国铁路建设和高铁事业伟大成就的精品站房工程。
          </div>
          <div>
            <span class="blue">在公共建筑领域，</span
            >公司建设了包含城市综合体、酒店、医院、学校、图书馆等百余座精品工程，建成国家图书馆、北京第九
          </div>
        </div>
      </div>
      <div class="first">
        届国际园林博览会主展馆、敦煌机场等一座座代表中国不同时期建筑最高水平的地标性建筑；北京2022年冬奥会张家口三场一村、北京城市副中心三大建筑、北京城市副中心站综合交通枢纽等多项国家重点工程；兰州中川机场枢纽、长沙黄花机场枢纽等多项机场综合枢纽，其中国家图书馆同时摘得鲁班奖、詹天佑奖，入选“北京当代十大建筑”、“新中国成立六十周年百项经典暨精品工程”、“改革开放35周年百项经典暨精品工程”。
      </div>
      <div class="first">
        <span class="blue">在商业地产与市政方面，</span
        >公司建造了一批包含商业写字楼、宜居住宅、文旅小镇等改善人居环境的精品地产项目，并在国家及省市重点公路、大型桥梁工程、市政广场、地下管廊、海绵城市等建设领域中取得卓越成绩，先后建设了天津英蓝金融中心、青岛国贸中心、海南丽湖半岛、上海曲靖至崇明段高速公路等系列工程，积极助力美丽宜居城市建设。
      </div>
      <div class="first">
        公司始终追求品质发展，立足科技创新、狠抓专业能力建设，以打造精品工程为总目标，深耕路内路外两个市场，不断推进公司规模化、效益化、规范化全面发展，致力于将企业打造成最具市场竞争力、最具价值创造力的一流建筑综合服务商！
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped lang="less">
.info {
  .content {
    .second {
      .second_con {
        flex: 1;
        height: 100%;
        display: flex;
        flex-direction: column;
      }
      .introimg {
        width: 28.13vw;
        height: 100%;
        background: url("../assets/image/introimg.png") no-repeat;
        background-position: 0 0;
        background-size: 100% 100%;
        margin-right: 1.56vw;
      }
      display: flex;
      width: 100%;
      height: 17.71vw;
      margin-bottom: 1.04vw;
    }
    .first {
      margin-bottom: 1.04vw;
    }
    .weatblue {
      color: rgba(25, 97, 172, 1);
      font-weight: 550;
    }
    .blue {
      color: rgba(25, 97, 172, 1);
      font-weight: 550;
    }
    width: 100%;
    height: 100%;
    color: rgba(18, 20, 58, 0.8);
    font-size: 0.83vw;
    line-height: 1.67vw;
  }
  .slh {
    position: absolute;
    top: 0;
    left: 4.58vw;
    width: 3.13vw;
    height: 2.71vw;
    background: url("../assets/image/surveyintro.png");
  }
  width: 100%;
  position: relative;
  padding: 3.75vw 4.58vw 3.65vw 4.58vw;
}
</style>
